import {
  Box,
  Autocomplete,
  Button,
  Container,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  Grid,
  Typography,
  Chip,
  CircularProgress,
  Link,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { ErrorMessage, Form, Formik } from "formik";
import DialogTitle from "@mui/material/DialogTitle";
import { useEditCategoryMutation } from "../redux/reducer/features/Product/productSlice";
import {
  DataGrid,
  GridColDef,
  GridRenderCellParams,
  GridToolbar,
  GridValueGetterParams,
} from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  useAddCategoryMutation,
  useDeleteCategoryMutation,
  useMigrateProductsMutation,
  useGetCategorListWithProductCountQuery,
} from "../redux/reducer/features/Product/productSlice";
import { useGetTaxanomyCategoriesMutation } from "../redux/reducer/features/Product/productSlice";
import {
  CatalogCategoryResponse,
  Category,
  CategoryValidationSchema,
  TaxanomyCategory,
} from "../models/features/Product/Product";
import TransformIcon from "@mui/icons-material/Transform";
export interface CategoryProps {}

export const Categories: React.FunctionComponent<CategoryProps> = () => {
  const { data, isLoading, refetch } = useGetCategorListWithProductCountQuery();

  const [categories, setCategories] = React.useState<CatalogCategoryResponse[]>(
    []
  );
  const [taxanomyCategories, setTaxanomyCategories] = React.useState<
    TaxanomyCategory[]
  >([]);
  const [selectedRow, setSelectedRow] = React.useState<Category>();
  const [categoryMutation, categoryMutationResult] = useAddCategoryMutation();
  const [migrateProductsMutation, migrateProductsMutationResult] =
    useMigrateProductsMutation();
  const [getTaxanomyMutation, getTaxanomyMutationResult] =
    useGetTaxanomyCategoriesMutation();
  const [editcategoryMutation, editcategoryMutationResult] =
    useEditCategoryMutation();
  const [deleteConfirm, setDeleteConfirm] = React.useState(false);
  const [edit, setEdit] = React.useState(false);
  const [deleteMutation, deleteMutationResult] = useDeleteCategoryMutation();
  const [Formopen, setFormOpen] = React.useState(false);
  const [openMigrate, setOpenMigrate] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [errorMessage, setErrorMessage] = React.useState("");
  const [searchQuery, setSearchQuery] = React.useState("");
  const [selectedRowCount, setSelectedRowCount] = React.useState<number>(0);
  const [migrationData, setMigrationData] = React.useState({
    sourceId: "",
    targetId: "",
  });
  const [debouncedQuery, setDebouncedQuery] = useState(searchQuery);
  const CategoryInitialValues: Category = {
    id: selectedRow?.id || "",
    title: selectedRow?.title || "",
    shortTitle: selectedRow?.shortTitle || "",
    shopifyTitle: selectedRow?.shopifyTitle || "",
    isSubCategory: selectedRow?.isSubCategory ?? false,
    parentCategoryId: selectedRow?.parentCategoryId || "",
    taxonomyCategoryId: selectedRow?.taxonomyCategoryId || "",
    taxonomyCategoryTitle: selectedRow?.taxonomyCategoryTitle || "",
  };

  const allCategoriesDefaultProps = {
    options:
      data && data.entityList
        ? data.entityList.filter(
            (n) => n.category.id !== migrationData.sourceId
          )
        : [],
    getOptionLabel: (option: any) => option.category.title,
  };

  const open = Boolean(anchorEl);
  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement>,
    item: CatalogCategoryResponse
  ) => {
    setSelectedRowCount(item.productCount);
    setAnchorEl(event.currentTarget);
    setSelectedRow(item.category);
  };
  const handleClose = () => {
    setFormOpen(false);
    setOpenMigrate(false);
    setErrorMessage("");
    setSearchQuery("");
    setSelectedRow({
      id: "",
      title: "",
      shortTitle: "",
      isSubCategory: false,
      taxonomyCategoryId: "",
      taxonomyCategoryTitle: "",
    });
  };
  const handleOnSubmit = (values: Category) => {
    setErrorMessage("");
    if (values.isSubCategory == false) {
      values.parentCategoryId = null;
    }
    if (edit) {
      editcategoryMutation({
        data: { id: selectedRow?.id, Category: values },
      }).then((res: any) => {
        if (res && res?.data) {
          if (res.data.status === 0) {
            refetch();
            setEdit(false);
            handleClose();
          } else if (res.data.status === 6) {
            setErrorMessage("This category already exists.");
            return;
          } else {
            setErrorMessage("Failed to update category.");
          }
        }
      });
    } else {
      categoryMutation({ data: { ...values, id: undefined } }).then(
        (res: any) => {
          if (res && res?.data) {
            if (res.data.status === 0) {
              refetch();
              handleClose();
            } else {
              setErrorMessage("This category already exists.");
              return;
            }
          }
        }
      );
    }
  };

  const handleClickOpen = () => {
    setFormOpen(true);
  };

  const handleGetTaxanomyCategories = () => {
    getTaxanomyMutation({ searchQuery: debouncedQuery }).then((res: any) => {
      if (res && res.data) {
        if (res.data.status === 200) {
          setTaxanomyCategories(res.data.entityList);
        } else {
          setTaxanomyCategories([]);
        }
      }
    });
  };
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQuery(searchQuery);
    }, 1500);

    return () => {
      clearTimeout(handler);
    };
  }, [searchQuery]);
  useEffect(() => {
    if (Formopen) {
      handleGetTaxanomyCategories();
    }
  }, [debouncedQuery, Formopen]);

  const onDeleteCategory = (item: Category) => {
    setDeleteConfirm(false);
    setCategories(categories.filter((i) => i.category.id !== item.id));

    deleteMutation({ data: { id: item.id } });
  };
  React.useEffect(() => {
    if (data) {
      setCategories(data && data.entityList ? data.entityList : []);
    }
  }, [data]);

  const handleMigrateProducts = () => {
    migrateProductsMutation({
      sourceId: migrationData.sourceId,
      targetId: migrationData.targetId,
    }).then((res: any) => {
      if (res && res.data) {
        if (res.data.status === 200) {
          handleClose();
          refetch();
        } else if (res.data.status === 404) {
          setErrorMessage("No Product Found for Migration!");
        }
      }
    });
  };

  const catColumns: GridColDef[] = [
    {
      field: "title",
      headerName: "Title",
      flex: 1,
      valueGetter: (params: GridValueGetterParams) => params.row.category.title,
    },
    {
      field: "shortTitle",
      headerName: "Short Title",
      flex: 1,
      valueGetter: (params: GridValueGetterParams) =>
        params.row.category.shortTitle,
    },
    {
      field: "shopifyTitle",
      headerName: "Shopify Title",
      flex: 1,
      valueGetter: (params: GridValueGetterParams) =>
        params.row.category.shopifyTitle,
    },
    {
      field: "productCount",
      headerName: "Product Count",
      flex: 1,
      align: "right",
      headerAlign: "right",
      filterable: false,
    },
    {
      field: "actions",
      headerName: "Actions",
      type: "actions",
      flex: 1,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <div>
            <IconButton
              id="basic-button"
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={(e) => {
                handleClick(e, params.row);
              }}
            >
              <MoreVertIcon />
            </IconButton>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={() => {
                setAnchorEl(null);
              }}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >
              <MenuItem
                onClick={() => {
                  setEdit(true);
                  setFormOpen(true);
                  setAnchorEl(null);
                }}
              >
                <ListItemIcon>
                  <EditIcon />
                </ListItemIcon>
                <ListItemText>Edit</ListItemText>
              </MenuItem>
              <MenuItem
                disabled={selectedRowCount > 0}
                onClick={() => {
                  setAnchorEl(null);
                  setDeleteConfirm(true);
                }}
              >
                <ListItemIcon>
                  <DeleteIcon />
                </ListItemIcon>
                <ListItemText>Delete</ListItemText>
              </MenuItem>
              <MenuItem
                disabled={selectedRowCount === 0}
                onClick={() => {
                  setAnchorEl(null);
                  setMigrationData({
                    sourceId: selectedRow?.id ?? "",
                    targetId: "",
                  });
                  setOpenMigrate(true);
                }}
              >
                <ListItemIcon>
                  <TransformIcon />
                </ListItemIcon>
                <ListItemText>Migrate</ListItemText>
              </MenuItem>
            </Menu>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <Container maxWidth={false}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography variant="h6" sx={{ fontWeight: "bold" }} gutterBottom>
            Categories
          </Typography>
          <Button
            size="small"
            variant="contained"
            onClick={() => {
              setEdit(false);
              handleClickOpen();
            }}
            startIcon={<AddIcon />}
          >
            Add New
          </Button>
        </Stack>

        <Box mt={2} sx={{ height: "70vh", width: "100%" }}>
          <DataGrid
            rows={categories.map((cat, index: number) => {
              return { ...cat, id: index };
            })}
            columns={catColumns}
            pageSize={10}
            rowsPerPageOptions={[10]}
            checkboxSelection={false}
            disableSelectionOnClick
            loading={isLoading}
            components={{ Toolbar: GridToolbar }}
            componentsProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 500 },
              },
            }}
          />
        </Box>
        <Dialog maxWidth="md" fullWidth open={Formopen} onClose={handleClose}>
          <DialogTitle alignSelf={"center"}>
            {" "}
            {edit ? "Edit" : "Add"} Category
          </DialogTitle>
          <DialogContent>
            <Formik
              initialValues={CategoryInitialValues}
              validationSchema={CategoryValidationSchema}
              onSubmit={(values) => {
                handleOnSubmit(values);
              }}
              enableReinitialize={true}
            >
              {({ values, handleChange, handleBlur, setFieldValue }) => (
                <>
                  <Form>
                    <Grid
                      container
                      spacing={3}
                      justifyContent="space-between"
                      display="flex"
                      p={5}
                    >
                      <Grid item xs={12} md={4}>
                        <TextField
                          id="title"
                          name="title"
                          label="Title"
                          fullWidth
                          autoComplete="family-name"
                          variant="standard"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.title}
                        />
                        <ErrorMessage
                          className="error-msg"
                          component={"div"}
                          name="title"
                        />
                      </Grid>

                      <Grid item xs={12} md={4}>
                        <TextField
                          id="shortTitle"
                          name="shortTitle"
                          label="Short Title"
                          fullWidth
                          autoComplete="shipping address-line1"
                          variant="standard"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.shortTitle}
                        />
                        <ErrorMessage
                          className="error-msg"
                          component={"div"}
                          name="shortTitle"
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <TextField
                          id="shopifyTitle"
                          name="shopifyTitle"
                          label="Shopify Title"
                          fullWidth
                          variant="standard"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.shopifyTitle}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Autocomplete
                          options={taxanomyCategories}
                          disabled={
                            values?.taxonomyCategoryTitle ? true : false
                          }
                          getOptionLabel={(option) => option.fullName}
                          loading={getTaxanomyMutationResult.isLoading}
                          id="taxonomyCategoryId"
                          componentName="taxonomyCategoryId"
                          clearOnEscape
                          onChange={(e, value) => {
                            setFieldValue(
                              "taxonomyCategoryId",
                              value?.id ?? ""
                            );
                            setFieldValue(
                              "taxonomyCategoryTitle",
                              value?.fullName ?? ""
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="standard"
                              label="Taxonomy Category"
                              onChange={(e) => {
                                setSearchQuery(e.target.value);
                              }}
                            />
                          )}
                        />
                        {values.taxonomyCategoryId ? null : (
                          <ErrorMessage
                            className="error-msg"
                            component={"div"}
                            name="taxonomyCategoryId"
                          />
                        )}
                        <Chip
                          sx={{
                            mt: 1,
                            display: values.taxonomyCategoryTitle ? "" : "none",
                          }}
                          label={values.taxonomyCategoryTitle}
                          onDelete={() => {
                            setFieldValue("taxonomyCategoryTitle", "");
                            setFieldValue("taxonomyCategoryId", "");
                          }}
                        ></Chip>
                      </Grid>
                      <Grid item xs={12}>
                        For Reference:
                        <Link
                          target="blank"
                          href="https://shopify.github.io/product-taxonomy/releases/unstable/"
                        >
                          https://shopify.github.io/product-taxonomy/releases/unstable/
                        </Link>
                      </Grid>
                      <Grid item xs={12} mt={3}>
                        <Grid
                          container
                          direction="row"
                          justifyContent="space-between"
                          alignItems="flex-end"
                        >
                          <Grid item>
                            <Button
                              color="error"
                              variant="contained"
                              onClick={() => {
                                handleClose();
                              }}
                            >
                              Cancel
                            </Button>
                          </Grid>
                          <Grid item>
                            <Typography color="error">
                              {errorMessage}
                            </Typography>
                          </Grid>
                          <Grid item>
                            <Button
                              variant="contained"
                              type="submit"
                              disabled={
                                categoryMutationResult.isLoading ||
                                editcategoryMutationResult.isLoading
                              }
                              endIcon={
                                categoryMutationResult.isLoading ||
                                editcategoryMutationResult.isLoading ? (
                                  <CircularProgress size="20px" />
                                ) : null
                              }
                            >
                              Save
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Form>
                </>
              )}
            </Formik>
          </DialogContent>
        </Dialog>
      </Container>
      <Dialog open={deleteConfirm} onClose={handleClose} fullWidth>
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          Confirm to delete
        </DialogTitle>
        <DialogContent>Are you sure to delete the Category?</DialogContent>
        <DialogActions>
          <Button
            autoFocus
            variant="outlined"
            onClick={() => {
              setDeleteConfirm(false);
            }}
          >
            No
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              if (selectedRow) onDeleteCategory(selectedRow);
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openMigrate} onClose={handleClose} fullWidth>
        <DialogTitle>
          Migrate Products from {selectedRow?.title} to a New Category
        </DialogTitle>
        <DialogContent>
          <FormControl fullWidth sx={{ mt: 2 }} variant="standard">
            <InputLabel id="demo-customized-select-label">
              From Category
            </InputLabel>
            <Select
              labelId="demo-customized-select-label"
              id="demo-customized-select"
              value={selectedRow?.title}
              fullWidth
            >
              <MenuItem value={selectedRow?.title}>
                {selectedRow?.title}
              </MenuItem>
            </Select>
          </FormControl>
          <Autocomplete
            sx={{ mt: 2 }}
            {...allCategoriesDefaultProps}
            id="migrationAutoComplete"
            loading={isLoading}
            clearOnEscape
            onChange={(e, value) => {
              setMigrationData({
                ...migrationData,
                targetId: value?.category.id ?? "",
              });
            }}
            renderInput={(params) => (
              <TextField {...params} label="To Category" variant="standard" />
            )}
          />
        </DialogContent>
        <DialogActions>
          {errorMessage ? (
            <Typography mr={2} color={"error"}>
              {errorMessage}
            </Typography>
          ) : null}
          <Button size="small" variant="outlined" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            disabled={
              migrationData.sourceId === "" ||
              migrationData.targetId === "" ||
              migrateProductsMutationResult.isLoading
            }
            endIcon={
              migrateProductsMutationResult.isLoading ? (
                <CircularProgress size={"20px"}></CircularProgress>
              ) : null
            }
            size="small"
            variant="contained"
            onClick={handleMigrateProducts}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
